import React from "react";
import { Popover, Table, TableProps } from "antd";
import { useSelector } from "react-redux";
import { userInfo } from "@/redux/reducers/user.reducer";
import { formatDistanceToNow } from "date-fns";
import { vi } from "date-fns/locale";
import { NormalStyles } from "@/layouts/styles/ssr.style";
import { definitions } from "@/services/metruyenvl";

function TableHistoriesCoin() {
    const userReducer = useSelector(userInfo);

    const columnsMob: TableProps<definitions["models.UserCoinMD"]>["columns"] = [
        {
            title: "Mô tả",
            dataIndex: "description",
            key: "description",
        },
        {
            title: "Coin",
            dataIndex: "bonus_coin",
            key: "bonus_coin",
        },
    ];

    const columns: TableProps<definitions["models.UserCoinMD"]>["columns"] = [
        {
            title: "Tiêu đề",
            dataIndex: "title",
            key: "title",
        },
        {
            title: "Mô tả",
            dataIndex: "description",
            key: "description",
        },
        {
            title: "Bonus coin",
            dataIndex: "bonus_coin",
            key: "bonus_coin",
        },
        {
            title: "Thời gian",
            dataIndex: "created_time",
            key: "created_time",
            render: (updatedTime: number) => {
                const date = new Date(updatedTime * 1000);
                const distance = formatDistanceToNow(date, {
                    locale: vi,
                    addSuffix: true,
                });
                return (
                    <NormalStyles>
                        <Popover content={distance} placement="top">
                            {distance}
                        </Popover>
                    </NormalStyles>
                );
            },
        },
    ];
    return (
        <div className="w-full">
            <Table dataSource={userReducer.listOrderHistories} rowKey="id" columns={columns} className="hidden md:block" />
            <Table dataSource={userReducer.listOrderHistories} rowKey="id" columns={columnsMob} className="md:hidden block" />
        </div>
    );
}

export default TableHistoriesCoin;
